/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SubstanceTypeDetailsDto = {
    readonly id?: string;
    readonly name?: string;
    readonly category?: SubstanceTypeDetailsDto.category;
};
export namespace SubstanceTypeDetailsDto {
    export enum category {
        ADDITIVE = 'ADDITIVE',
        BASE_OIL = 'BASE_OIL',
    }
}

